(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const PRODUCT_PATH = /\/products\/([^/?#]+)/;

  const cartUpsells = {
    'prime-choice-deep-calm-formula': 'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed',
    'prime-choice-prime-brain': 'prime-choice-prime-one',
    'prime-choice-alpha-drive': 'creatine',
    'prime-choice-test-ultra': 'creatine',
    'prime-choice-collagen-complex-i-ii-iii-v-x-womens-90-caps': 'prime-choice-face-serum-womens-2oz',
    'collagen-complex-i-ii-iii-v-x-90-caps-copy': 'prime-choice-face-serum-womens-2oz',
    'prime-choice-hair-skin-nails-ultra-womens': 'prime-choice-face-serum-womens-2oz',
    'hair-skin-nails-ultra-mens': 'face-serum-mens-2oz',
    'prime-choice-digestive-plus': 'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-gut-flush': 'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-shred-fast': 'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'shred-fast-1-month-supply': 'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed': 'prime-choice-deep-calm-formula',
  };

  const bundleUpgrades = {
    'prime-choice-deep-calm-formula': 'prime-brain-deep-sleep-bundle',
    'prime-choice-prime-brain': 'prime-brain-deep-sleep-bundle',
    'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed': 'prime-brain-deep-sleep-bundle',
    'prime-choice-alpha-drive': 'get-shredded-muscle-pack',
    'prime-choice-test-ultra': 'get-shredded-muscle-pack',
    'creatine': 'get-shredded-muscle-pack',
    'prime-choice-collagen-complex-i-ii-iii-v-x-womens-90-caps': 'womens-wellness-pack',
    'collagen-complex-i-ii-iii-v-x-90-caps-copy': 'womens-wellness-pack',
    'prime-choice-hair-skin-nails-ultra-womens': 'womens-wellness-pack',
    'prime-choice-face-serum-womens-2oz': 'womens-wellness-pack',
    'prime-choice-digestive-plus': 'complete-full-body-detox',
    'prime-choice-gut-flush': 'complete-full-body-detox',
    'prime-choice-probiotic-60b-digestion-gutbalance-wellness': 'complete-full-body-detox',
    'prime-choice-shred-fast': '24hr-weight-loss-bundle',
    'shred-fast-1-month-supply': '24hr-weight-loss-bundle',
    'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support': '24hr-weight-loss-bundle',
    'prime-choice-sea-moss': '24hr-weight-loss-bundle',
  };

  const replenishable = new Set([
    ...Object.keys(cartUpsells),
    'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'prime-choice-sea-moss',
    'prime-choice-prime-one',
    'prime-choice-face-serum-womens-2oz',
    'face-serum-mens-2oz',
  ]);

  const productCache = new Map();
  let productPending = false;
  let cartPending = false;

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const moneyValue = (text) => {
    const normalized = String(text || '').replace(/[^0-9,.-]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const normalizeDiscountBadges = (root = document) => {
    root.querySelectorAll('.pc-sale-badge, .pc-cart-sale-badge').forEach((badge) => {
      const scope = badge.closest('.card-wrapper, .pc-buybox, .cart-item, product-info') || badge.parentElement;
      const regular = moneyValue(
        scope?.querySelector('.pc-cart-compare-price, s.price-item--regular')?.textContent,
      );
      const sale = moneyValue(
        scope?.querySelector('.pc-cart-sale-price, .price-item--sale.price-item--last')?.textContent,
      );
      if (regular === null || sale === null || regular <= sale) return;
      badge.textContent = `Save ${Math.round(((regular - sale) / regular) * 100)}%`;
    });
  };

  const productHandle = () => decodeURIComponent(location.pathname.match(PRODUCT_PATH)?.[1] || '');

  const fetchProduct = async (handle) => {
    if (!handle) return null;
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' },
        }).then((response) => (response.ok ? response.json() : null)).catch(() => null),
      );
    }
    return productCache.get(handle);
  };

  const availableVariant = (product) => product?.variants?.find((variant) => variant.available) || null;

  const productImage = (product) => {
    const source = product?.featured_image || product?.images?.[0] || '';
    if (!source) return '';
    return source.startsWith('//') ? `https:${source}` : source;
  };

  const productCard = (product, eyebrow, buttonText) => {
    const variant = availableVariant(product);
    if (!variant) return null;

    const card = document.createElement('section');
    card.className = 'pc-aov-card';
    card.dataset.variantId = variant.id;

    const image = productImage(product);
    const url = product.url || `${ROOT}products/${product.handle}`;
    card.innerHTML = `
      ${image ? `<a class="pc-aov-card__image" href="${escapeHtml(url)}"><img src="${escapeHtml(image)}" alt="" loading="lazy"></a>` : ''}
      <div class="pc-aov-card__content">
        <span class="pc-aov-card__eyebrow">${escapeHtml(eyebrow)}</span>
        <a class="pc-aov-card__title" href="${escapeHtml(url)}">${escapeHtml(product.title)}</a>
        <span class="pc-aov-card__price">${money(variant.price)}</span>
        <button class="pc-aov-card__button" type="button">${escapeHtml(buttonText)}</button>
        <p class="pc-aov-card__status" role="status" aria-live="polite"></p>
      </div>`;
    return card;
  };

  const addItem = async (variantId, button, status) => {
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionIds = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [];
    button.disabled = true;
    button.classList.add('is-loading');
    status.textContent = '';

    try {
      const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }
      const response = await fetch(window.routes?.cart_add_url || `${ROOT}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Unable to add this item.');

      button.textContent = 'Added';
      status.textContent = 'Added to your cart.';
      if (cartDrawer && state.sections) {
        delete cartDrawer.dataset.pcAovCartChecked;
        cartDrawer.renderContents(state);
      }
      document.dispatchEvent(new CustomEvent('pc:aov-item-added', { detail: { variantId } }));
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item.';
      button.disabled = false;
    } finally {
      button.classList.remove('is-loading');
    }
  };

  const bindAdd = (card) => {
    const button = card.querySelector('.pc-aov-card__button');
    const status = card.querySelector('.pc-aov-card__status');
    button.addEventListener('click', () => addItem(card.dataset.variantId, button, status));
  };

  const quantityInput = () => {
    return document.querySelector('.pc-buybox input[name="quantity"]') ||
      [...document.querySelectorAll('product-info input[name="quantity"]')]
        .find((input) => input.offsetWidth || input.offsetHeight) ||
      document.querySelector('input[name="quantity"]');
  };

  const buildSupplySelector = () => {
    const wrapper = document.createElement('section');
    wrapper.className = 'pc-aov-supply';
    wrapper.innerHTML = `
      <div class="pc-aov-heading">Choose your supply</div>
      <p class="pc-aov-copy">Select your preferred supply, then add it to cart.</p>
      <div class="pc-aov-supply__options" role="group" aria-label="Supply quantity">
        <button type="button" data-quantity="1" class="is-active">1 month</button>
        <button type="button" data-quantity="2">2 months</button>
        <button type="button" data-quantity="3">3 months</button>
      </div>`;

    wrapper.querySelectorAll('[data-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = quantityInput();
        if (!input) return;
        input.value = button.dataset.quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        wrapper.querySelectorAll('[data-quantity]').forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });
    return wrapper;
  };

  const renderProductPage = async () => {
    const handle = productHandle();
    if (!handle || productPending || document.querySelector('[data-pc-aov-product]')) return;

    const host = document.querySelector('.pc-buybox .pc-product-facts')?.closest('.block') || document.querySelector('.pc-buybox .pc-cta') || document.querySelector('product-info product-form');
    if (!host) return;
    productPending = true;

    const region = document.createElement('div');
    region.className = 'pc-aov-product';
    region.dataset.pcAovProduct = 'true';

    if (replenishable.has(handle)) region.appendChild(buildSupplySelector());

    const bundleHandle = bundleUpgrades[handle];
    if (bundleHandle) {
      const product = await fetchProduct(bundleHandle);
      const card = productCard(product, 'Upgrade to the complete routine', 'Add bundle');
      if (card) {
        card.classList.add('pc-aov-card--bundle');
        bindAdd(card);
        region.appendChild(card);
      }
    }

    if (region.children.length) host.insertAdjacentElement('afterend', region);
    productPending = false;
  };

  const firstCartRecommendation = (cart) => {
    const handles = new Set((cart.items || []).map((item) => item.handle));
    for (const item of cart.items || []) {
      const target = cartUpsells[item.handle];
      if (target && !handles.has(target)) return target;
    }
    return null;
  };

  const renderCartUpsell = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || cartPending || drawer.dataset.pcAovCartChecked === 'true' || drawer.querySelector('[data-pc-aov-cart]')) return;
    cartPending = true;
    drawer.dataset.pcAovCartChecked = 'true';

    const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .catch(() => ({ items: [] }));
    const target = firstCartRecommendation(cart);
    if (!target) {
      cartPending = false;
      return;
    }

    const product = await fetchProduct(target);
    const card = productCard(product, 'Complete your routine', 'Add');
    const items = drawer.querySelector('cart-drawer-items');
    if (!card || !items) {
      cartPending = false;
      return;
    }

    const region = document.createElement('div');
    region.className = 'pc-aov-cart';
    region.dataset.pcAovCart = 'true';
    region.appendChild(card);
    bindAdd(card);
    items.appendChild(region);
    drawer.querySelector('.cart-collection')?.classList.add('pc-aov-generic-hidden');
    cartPending = false;
  };

  let queued = false;
  const init = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(async () => {
      queued = false;
      await renderProductPage();
      await renderCartUpsell();
      normalizeDiscountBadges();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  let productRetries = 0;
  const productTimer = window.setInterval(() => {
    productRetries += 1;
    init();
    if (document.querySelector('[data-pc-aov-product]') || !productHandle() || productRetries >= 20) {
      window.clearInterval(productTimer);
    }
  }, 250);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#cart-icon-bubble, product-form button[name="add"]')) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer) delete drawer.dataset.pcAovCartChecked;
    window.setTimeout(init, 700);
  }, true);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('pc:aov-item-added', () => setTimeout(init, 150));

  window.setTimeout(normalizeDiscountBadges, 500);
  window.setTimeout(normalizeDiscountBadges, 1500);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) delete drawer.dataset.pcAovCartChecked;
      window.setTimeout(init, 200);
    });
  }
})();
